import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=31c27eb7&scoped=true"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c27eb7",
  null
  
)

export default component.exports